{
    "(None)": "",
    "(save {highestYearlyDiscount}%)": "(tiết kiệm {highestYearlyDiscount}%)",
    "{amount} days free": "{amount} ngày đọc thử",
    "{amount} off": "Giảm {amount}",
    "{amount} off for first {number} months.": "Giảm {amount} cho {number} tháng đầu tiên.",
    "{amount} off for first {period}.": "Giảm {amount} cho {period} đầu tiên.",
    "{amount} off forever.": "Giảm {amount} vĩnh viễn.",
    "{buyerName} has gifted you a <strong>{duration}-month</strong> {tierName} membership to {siteTitle}_other": "",
    "{buyerName} has gifted you a <strong>{duration}-year</strong> {tierName} membership to {siteTitle}": "",
    "{discount}% discount": "Giảm {discount}%",
    "{duration} membership": "",
    "{field}: {message}": "",
    "{memberEmail} will no longer receive {newsletterName} newsletter.": "{memberEmail} sẽ không còn được nhận bản tin {newsletterName}.",
    "{memberEmail} will no longer receive emails when someone replies to your comments.": "{memberEmail} sẽ không còn được nhận email khi ai đó trả lời bình luận.",
    "{memberEmail} will no longer receive this newsletter.": "{memberEmail} sẽ không còn được nhận bản tin này.",
    "{memberEmail} will no longer receive updates & announcements.": "{memberEmail} sẽ không còn được nhận cập nhật & thông báo.",
    "{months} month": "",
    "{months} months": "{months} tháng",
    "{months} months free": "Miễn phí {months} tháng",
    "{tierName} membership": "Thành viên {tierName}",
    "{trialDays} days free": "{trialDays} ngày đọc thử miễn phí",
    "{years} years": "{years} năm",
    "+1 (123) 456-7890": "+84 (987) 654-321",
    "1 month": "1 tháng",
    "1 month free": "Miễn phí 1 tháng",
    "1 year": "1 năm",
    "A gift, just for you": "Một món quà, dành riêng cho bạn",
    "Access your RSS feeds": "Truy cập các nguồn tin RSS của bạn",
    "Account": "Tài khoản",
    "Account details updated successfully": "Đã cập nhật chi tiết tài khoản thành công",
    "Account settings": "Cài đặt",
    "Add a personal note": "Thêm lưu ý về người này",
    "Add a short note to go with your gift": "",
    "Address line 1": "",
    "Address line 2": "",
    "After a free trial ends, you will be charged the regular price for the tier you've chosen. You can always cancel before then.": "Sau khi hết hạn đọc thử miễn phí, sẽ tính phí với gói thành viên mà bạn đã chọn. Bạn có thể hủy gói trước khi hết hạn đọc thử.",
    "Already a member?": "Bạn đã là thành viên?",
    "An error occurred": "Xảy ra lỗi",
    "An unexpected error occured. Please try again or <a>contact support</a> if the error persists.": "Xảy ra lỗi chưa biết. Hãy thử lại hoặc <a>liên hệ hỗ trợ</a> nếu vẫn tiếp tục lỗi.",
    "Back": "Quay về",
    "Back to Log in": "Quay về đăng nhập",
    "Before you go": "Trước khi bạn rời đi",
    "Billing info & receipts": "Thông tin thanh toán & hóa đơn",
    "Black Friday": "Ưu Đãi",
    "Bluesky": "Bluesky",
    "Buy": "",
    "Buying for someone else?": "",
    "Cancel anytime.": "Hủy bất cứ lúc nào.",
    "Cancel subscription": "Hủy gói",
    "Canceled": "Đã hủy",
    "Cancellation reason": "Lý do hủy gói",
    "Change": "Thay đổi",
    "Change plan": "Thay đổi gói",
    "Check spam & promotions folders": "Kiểm tra thư mục spam & quảng cáo",
    "Check with your mail provider": "Yêu cầu nhà cung cấp dịch vụ email hỗ trợ",
    "Check your inbox to verify email update": "Kiểm tra email của bạn để xác minh cập nhật email",
    "Choose": "Chọn",
    "Choose a date from today onwards": "",
    "Choose a date within the next year": "",
    "Choose a delivery date": "",
    "Choose a different plan": "Chọn gói khác",
    "Choose a plan": "Chọn một gói",
    "Choose a tier": "",
    "Choose your newsletters": "Chọn bản tin bạn muốn nhận",
    "City": "",
    "Click here to retry": "Nhấn vào đây thử lại",
    "Click the confirmation link in your inbox to finish redeeming your membership. If it doesn't arrive within 3 minutes, check your spam folder.": "Hãy nhấn vào liên kết xác nhận trong hộp thư đến của bạn để hoàn tất việc kích hoạt tư cách thành viên. Nếu bạn không nhận được email trong vòng 3 phút, hãy kiểm tra thư mục spam.",
    "Close": "Đóng",
    "Code": "Mã",
    "Comment preferences updated.": "Đã cập nhật thiết lập bình luận.",
    "Comments": "Bình luận",
    "Complimentary": "Trải nghiệm",
    "Confirm": "Xác nhận",
    "Confirm cancellation": "Xác nhận hủy",
    "Confirm subscription": "Xác nhận đăng ký",
    "Contact support": "Liên hệ hỗ trợ",
    "Continue": "Tiếp tục",
    "Continue subscription": "Tiếp tục đăng ký",
    "Continue to delivery details": "",
    "Continue to payment": "",
    "Continue with a paid subscription anytime. Your remaining gift period will be added as a free trial.": "Bạn có thể tiếp tục sử dụng gói trả phí bất cứ lúc nào. Thời gian sử dụng còn lại sẽ được tính là thời gian đọc thử miễn phí.",
    "Copied": "Đã sao chép",
    "Copy": "Sao chép",
    "Copy link": "Sao chép liên kết",
    "Could not create Stripe billing portal session": "Không thể tạo phiên cổng thanh toán Stripe",
    "Could not create Stripe checkout session": "Không thể tạo phiên thanh toán Stripe",
    "Could not sign in. Login link expired.": "Không thể đăng nhập. Liên kết đăng nhập hết hạn.",
    "Could not update email! Invalid link.": "Không thể cập nhật email. Liên kết không hợp lệ.",
    "Country": "",
    "Create a new contact": "Tạo liên hệ mới",
    "Current plan": "Gói hiện tại",
    "Delete account": "Xóa tài khoản",
    "Delivery date": "",
    "Delivery method": "",
    "Didn't mean to do this? Manage your preferences <button>here</button>.": "Không muốn như vậy? Quản lý thiết lập <button>ở đây</button>.",
    "Don't have an account?": "Chưa có tài khoản?",
    "Edit": "Chỉnh sửa",
    "Email": "Email",
    "Email confirmation link expired.": "",
    "Email it to them": "",
    "Email newsletter": "Bản tin email",
    "Email newsletter settings updated": "Đã cập nhật thiết lập bản tin email",
    "Email preferences": "Thiết lập email",
    "Email preferences updated.": "Đã cập nhật thiết lập gửi email.",
    "Emails": "Email",
    "Emails disabled": "Vô hiệu hóa email",
    "Ends {offerEndDate}": "Kết thúc {offerEndDate}",
    "Enjoy {amountOff} off forever.": "Tận hưởng giảm {amountOff} vĩnh viễn.",
    "Enjoy {months} free months on us.": "Tận hưởng {months} tháng đọc miễn phí.",
    "Enjoy {months} free months on us. You won't be charged until {newBillingDate}.": "Tận hưởng {months} tháng đọc miễn phí. Bạn sẽ không bị tính phí cho tới {newBillingDate}.",
    "Enjoy a free month on us.": "Tận hưởng một tháng đọc miễn phí.",
    "Enjoy a free month on us. You won't be charged until {newBillingDate}.": "Tận hưởng một tháng đọc miễn phí. Bạn sẽ không bị tính phí cho tới {newBillingDate}.",
    "Enter code above": "Nhập mã ở trên",
    "Enter the recipient's email address": "",
    "Enter your email address": "Nhập địa chỉ email của bạn",
    "Enter your name": "Nhập tên của bạn",
    "Error": "Lỗi",
    "Expires {expiryDate}": "Hết hạn {expiryDate}",
    "Facebook": "Facebook",
    "Failed to cancel subscription, please try again": "Không thể hủy gói, vui lòng thử lại",
    "Failed to log in, please try again": "Không thể đăng nhập, vui lòng thử lại",
    "Failed to log out, please try again": "Không thể đăng xuất, vui lòng thử lại",
    "Failed to open billing portal, please try again": "Không thể mở cổng thanh toán, vui lòng thử lại",
    "Failed to process checkout, please try again": "Không thể thanh toán, vui lòng thử lại",
    "Failed to send magic link email": "Không thể gửi liên kết đăng nhập qua email",
    "Failed to send verification email": "Không thể gửi email xác minh",
    "Failed to sign up, please try again": "Không thể đăng ký, vui lòng thử lại",
    "Failed to update account data": "Không thể cập nhật thông tin tài khoản",
    "Failed to update account details": "Không thể cập nhật chi tiết tài khoản",
    "Failed to update billing information, please try again": "Không thể cập nhật thông tin thanh toán, vui lòng thử lại",
    "Failed to update newsletter settings": "Không thể cập nhật thiết lập bản tin email",
    "Failed to update subscription, please try again": "Không thể cập nhật gói, vui lòng thử lại",
    "Failed to verify code, please try again": "Không thể xác minh mã, vui lòng thử lại",
    "For a friend or colleague": "",
    "Forever": "Vĩnh viễn",
    "Free Trial – Ends {trialEnd}": "Đọc Thử – Hết hạn vào {trialEnd}",
    "From": "",
    "Get help": "Trợ giúp",
    "Get in touch for help": "Yêu cầu trợ giúp",
    "Get notified when someone replies to your comment": "Thông báo khi có ai đó trả lời bình luận",
    "Gift a membership": "Tặng gói thành viên",
    "Gift could not be redeemed": "Không thể đổi quà",
    "Gift details": "Chi tiết quà tặng",
    "Gift duration": "",
    "Gift link copied to clipboard": "",
    "Gift membership": "",
    "Gift redeemed! You're all set.": "Đã đổi quà! Mọi thứ sẵn sàng rồi.",
    "Gift subscription": "Tặng gói thành viên",
    "Gift subscriptions are not available right now.": "Tặng gói thành viên hiện không khả dụng.",
    "Gift value": "Giá trị quà tặng",
    "Give feedback on this post": "Phản hồi bài viết này",
    "Help! I'm not receiving emails": "Trợ giúp! Tôi không nhận được email",
    "Here are a few other sites you may enjoy.": "Đây là vài trang khác mà bạn có thể thích.",
    "Hi {recipientName},": "",
    "Hide details": "Ẩn chi tiết",
    "How would you like to share this gift?": "",
    "I'll share it myself": "",
    "If a newsletter is flagged as spam, emails are automatically disabled for that address to make sure you no longer receive any unwanted messages.": "Nếu một bản tin email bị gắn nhãn thư rác, email sẽ tự động bị vô hiệu hóa đối với địa chỉ đó để đảm bảo bạn không còn nhận được bất kỳ email không mong muốn nào nữa.",
    "If the spam complaint was accidental, or you would like to begin receiving emails again, you can resubscribe to emails by clicking the button on the previous screen.": "Nếu khiếu nại về thư rác là vô tình hoặc bạn muốn bắt đầu nhận lại bản tin email, bạn có thể hoàn tác bằng cách nhấn vào nút trên màn hình trước đó.",
    "If you cancel your subscription now, you will continue to have access until {periodEnd}.": "Nếu bạn hủy gói lúc này, bạn sẽ có quyền truy cập tiếp tục cho đến {periodEnd}.",
    "If you have a corporate or government email account, reach out to your IT department and ask them to allow emails to be received from {senderEmail}": "Nếu bạn dùng tài khoản email của công ty hoặc chính phủ, hãy liên hệ bộ phận IT và yêu cầu họ cho phép nhận email từ {senderEmail}",
    "If you have an account, a login link has been sent to your inbox. If it doesn't arrive in 3 minutes, be sure to check your spam folder.": "Liên kết đăng nhập đã được gửi đến email của bạn. Nếu sau 3 phút vẫn chưa thấy, hãy kiểm tra thư mục spam.",
    "If you have an account, an email has been sent to {submittedEmailOrInbox}. Click the link inside or enter your code below.": "Liên kết đăng nhập đã được gửi đến {submittedEmailOrInbox}. Nhấn vào liên kết trong thư hoặc nhập mã của bạn bên dưới.",
    "If you would like to start receiving emails again, the best next steps are to check your email address on file for any issues and then click resubscribe on the previous screen.": "Nếu bạn muốn bắt đầu nhận lại bản tin email, tốt nhất là kiểm tra địa chỉ email của bạn trong hồ sơ xem có vấn đề gì không và sau đó nhấn vào nhận lại trên màn hình.",
    "If you're not receiving the email newsletter you've subscribed to, here are a few things to check.": "Nếu bạn không nhận được bản tin email mà bạn đã đăng ký, hãy kiểm tra những điều sau.",
    "If you've completed all these checks and you're still not receiving emails, you can reach out to get support by contacting {supportAddress}.": "Nếu bạn đã hoàn tất các bước kiểm tra này mà vẫn không nhận được bản tin email, hãy liên hệ {supportAddress} để được hỗ trợ.",
    "In the event a permanent failure is received when attempting to send a newsletter, emails will be disabled on the account.": "Trong trường hợp nhận được lỗi vĩnh viễn khi cố gắng gửi bản tin, tài khoản sẽ không nhận được bản tin email.",
    "In your email client add {senderEmail} to your contacts list. This signals to your mail provider that emails sent from this address should be trusted.": "Trong ứng dụng email của bạn, hãy thêm {senderEmail} vào danh sách liên hệ của bạn. Điều này báo hiệu cho nhà cung cấp dịch vụ email của bạn rằng các email được gửi từ địa chỉ này là đáng tin cậy.",
    "Invalid email address": "Địa chỉ email không hợp lệ",
    "Invalid verification code": "Mã xác minh không hợp lệ",
    "Jamie Larson": "Nguyễn Minh Anh",
    "jamie@example.com": "anh@example.com",
    "Less like this": "Gửi ít hơn",
    "LinkedIn": "LinkedIn",
    "Make sure emails aren't accidentally ending up in the Spam or Promotions folders of your inbox. If they are, click on \"Mark as not spam\" and/or \"Move to inbox\".": "Hãy chắc rằng email không đang trong thư mục Spam hoặc Quảng cáo. Nếu đang vậy, chọn \"Đánh dấu không phải spam\" hoặc \"Chuyển tới Hộp thư đến\".",
    "Manage": "Quản lý",
    "Maybe later": "Để sau",
    "Membership details": "Chi tiết gói thành viên",
    "Memberships from this email domain are currently restricted.": "Thành viên từ dịch vụ email này đang bị hạn chế.",
    "Memberships unavailable, contact the owner for access.": "Chưa phải là thành viên, liên hệ với chủ sở hữu để truy cập.",
    "month": "tháng",
    "Monthly": "Hàng tháng",
    "More like this": "Gửi nhiều hơn",
    "More options": "Lựa chọn khác",
    "Name": "Tên",
    "Need more help? Contact support": "Cần giúp đỡ? Liên hệ hỗ trợ",
    "Newsletters can be disabled on your account for two reasons: A previous email was marked as spam, or attempting to send an email resulted in a permanent failure (bounce).": "Tài khoản của bạn có thể không nhận được bản tin email bởi hai lý do: Email trước đó đã bị đánh dấu là thư rác hoặc lỗi thất bại vĩnh viễn (thư bị trả lại).",
    "No member exists with this e-mail address.": "Chưa có thành viên nào với email này",
    "No thanks, I want to cancel": "Cảm ơn, tôi vẫn muốn hủy",
    "Not ready to share? We've also emailed a copy to your inbox.": "Chưa sẵn sàng chia sẻ? Chúng tôi cũng đã gửi email một bản sao cho bạn.",
    "Not receiving emails?": "Bạn không nhận được email?",
    "Now": "",
    "Now check your email!": "Kiểm tra hộp thư ngay!",
    "Occasional updates from {siteTitle}": "Thông tin cập nhật định kỳ từ {siteTitle}",
    "Once resubscribed, if you still don't see emails in your inbox, check your spam folder. Some inbox providers keep a record of previous spam complaints and will continue to flag emails. If this happens, mark the latest newsletter as 'Not spam' to move it back to your primary inbox.": "Sau khi chọn nhận lại, nếu bạn vẫn không thấy email trong hộp thư đến của mình, hãy kiểm tra thư mục Spam. Một số nhà cung cấp email lưu giữ hồ sơ về các khiếu nại thư rác trước đây và sẽ tiếp tục phân loại email. Nếu điều này xảy ra, hãy đánh dấu bản tin email mới nhất là 'Không phải Spam' để chuyển nó trở lại hộp thư đến của bạn.",
    "Open AOL Mail": "Mở AOL Mail",
    "Open email": "Mở email",
    "Open Feedbin": "Mở Feedbin",
    "Open Gmail": "Mở Gmail",
    "Open Hey": "Mở Hey",
    "Open iCloud Mail": "Mở iCloud Mail",
    "Open Mail.ru": "Mở Mail.ru",
    "Open Outlook": "Mở Outlook",
    "Open Proton Mail": "Mở Proton Mail",
    "Open Yahoo Mail": "Mở Yahoo Mail",
    "Optional message": "",
    "Permanent failure (bounce)": "Thất bại vĩnh viễn (thư bị trả lại)",
    "Phone number": "Số điện thoại",
    "Plan": "Gói thành viên",
    "Plan checkout was cancelled.": "Đã hủy thanh toán gói.",
    "Plan upgrade was cancelled.": "Đã hủy nâng cấp gói.",
    "Please contact {supportAddress} to adjust your complimentary subscription.": "Vui lòng liên hệ {supportAddress} để điều chỉnh gói thành viên của bạn.",
    "Please enter {fieldName}": "Xin nhập {fieldName}",
    "Please fill in required fields": "Vui lòng điền các mục bắt buộc",
    "Podcasts": "Podcast",
    "Postal code": "",
    "Re-enable emails": "Kích hoạt lại email",
    "Recipient's email": "",
    "Recipient's name": "",
    "Recommendations": "Đề xuất",
    "Redeem your gift": "",
    "Redeeming...": "Đang đổi...",
    "Renews at {price}.": "Phí gia hạn {price}.",
    "Resume subscription": "Tiếp tục gói",
    "Retry": "Thử lại",
    "Save": "Lưu",
    "Save {amountOff} on your next {durationInMonths} billing cycles. Then {currency}{originalPrice}/{cadence}.": "Tiết kiệm {amountOff} cho kỳ thanh toán {durationInMonths} tiếp theo của bạn. Sau đó là {currency}{originalPrice}/{cadence}.",
    "Save {amountOff} on your next billing cycle. Then {currency}{originalPrice}/{cadence}.": "Tiết kiệm {amountOff} cho kỳ thanh toán tiếp theo của bạn. Sau đó là {currency}{originalPrice}/{cadence}.",
    "Send the link below to share it with whoever you'd like.": "Gửi liên kết bên dưới để chia sẻ nó với bất cứ ai mà bạn thích.",
    "Sending login link...": "Đang gửi liên kết đăng nhập...",
    "Sending...": "Đang gửi...",
    "Share": "Chia sẻ",
    "Share a full membership to {siteTitle} with a friend or colleague": "Chia sẻ gói thành viên {siteTitle} với một người bạn hoặc đồng nghiệp",
    "Share it yourself": "",
    "Show all": "Hiện toàn bộ",
    "Sign in": "Đăng nhập",
    "Sign out": "Đăng xuất",
    "Sign up": "Đăng ký",
    "Signup error: Invalid link": "Lỗi đăng ký: Liên kết không hợp lệ",
    "Signups from this email domain are currently restricted.": "Tên miền email này đang bị hạn chế đăng ký.",
    "Something went wrong, please try again later.": "Xảy ra lỗi, hãy thử lại sau.",
    "Sorry, no paid plans are available.": "Rất tiếc, không có gói trả phí.",
    "Sorry, no recommendations are available right now.": "Rất tiếc, chưa có đề xuất nào vào lúc này.",
    "Sorry, that didn’t work.": "Rất tiếc, không dùng được.",
    "Spam complaints": "Than phiền",
    "Start {amount}-day free trial": "Bắt đầu {amount} ngày đọc thử",
    "Starting {startDate}": "Bắt đầu {startDate}",
    "Starting today": "Bắt đầu hôm nay",
    "State": "",
    "Submit feedback": "Gửi phản hồi",
    "Subscribe": "Đăng ký",
    "Subscribed": "Đã đăng ký",
    "Subscription plan updated successfully": "Đã cập nhật gói thành viên thành công",
    "Success": "Thành công",
    "Success! Check your email for magic link to sign-in.": "Xong! Kiểm tra hộp thư để nhận liên kết đăng nhập.",
    "Success! Your account is fully activated, you now have access to all content.": "Xong! Đã kích hoạt tài khoản, giờ bạn có thể truy cập toàn bộ nội dung.",
    "Success! Your email is updated.": "Xong! Đã cập nhật email của bạn.",
    "Successfully unsubscribed": "Đã hủy gói thành công",
    "Taylor Reid": "",
    "taylor@example.com": "",
    "Thank you for subscribing. Before you start reading, below are a few other sites you may enjoy.": "Cảm ơn đã đăng ký. Trước khi bắt đầu đọc, hãy xem thử vài trang khác mà bạn có thể thích.",
    "Thank you for your support": "Cảm ơn bạn đã ủng hộ",
    "Thank you for your support!": "Cảm ơn bạn đã ủng hộ!",
    "Thanks for the feedback!": "Cám ơn phản hồi của bạn!",
    "That didn't go to plan": "Không thực hiện được",
    "The email address we have for you is {memberEmail} — if that's not correct, you can update it in your <button>account settings area</button>.": "Địa chỉ email của bạn là {memberEmail} — nếu sai, bạn có thể đổi trong <button>Cài đặt tài khoản</button>.",
    "There was a problem submitting your feedback. Please try again a little later.": "Có vấn đề khi gửi phản hồi. Hãy thử lại sau.",
    "There was an error cancelling your subscription, please try again.": "Xảy ra lỗi khi hủy gói thành viên, vui lòng thử lại",
    "There was an error continuing your subscription, please try again.": "Xảy ra lỗi khi tiếp tục gói thành viên, vui lòng thử lại",
    "There was an error processing your payment. Please try again.": "Xảy ra lỗi khi tiến hành thanh toán. Hãy thử lại sau.",
    "There was an error sending the email, please try again": "Xảy ra lỗi khi gửi email, vui lòng thử lại",
    "This gift can only be redeemed once and expires on {expiryDate}.": "",
    "This gift has already been consumed.": "Món quà này đã được sử dụng hết.",
    "This gift has already been redeemed.": "Món quà này đã được đổi.",
    "This gift has been refunded.": "Món quà này đã được hoàn tiền.",
    "This gift has expired.": "Món quà này đã hết hạn.",
    "This gift link is invalid.": "",
    "This site is invite-only, contact the owner for access.": "Trang web này chỉ dành cho những người được mời, hãy liên hệ với chủ sở hữu để cấp quyền truy cập.",
    "This site is not accepting donations at the moment.": "Trang web này hiện chưa nhận quyên góp.",
    "This site is not accepting payments at the moment.": "Trang web này hiện chưa chấp nhận thanh toán.",
    "This site only accepts paid members.": "Trang web này chỉ dành cho thành viên trả phí.",
    "This unsubscribe link belongs to a different email address than the one you are signed in with.": "",
    "Threads": "Threads",
    "Tier": "Gói",
    "To": "",
    "To complete signup, click the confirmation link in your inbox. If it doesn't arrive within 3 minutes, check your spam folder!": "Để hoàn tất đăng ký, nhấn vào liên kết xác nhận được gửi tới email của bạn. Sau 3 phút mà không thấy, hãy kiểm tra thư mục Spam!",
    "To continue to stay up to date, subscribe to {publication} below.": "Để tiếp tục được cập nhật, hãy đăng ký {publication} bên dưới.",
    "Too many attempts try again in {number} days.": "Thử quá nhiều, hãy thử lại sau {number} ngày.",
    "Too many attempts try again in {number} hours.": "Thử quá nhiều, hãy thử lại sau {number} giờ.",
    "Too many attempts try again in {number} minutes.": "Thử quá nhiều, hãy thử lại sau {number} phút.",
    "Too many different sign-in attempts, try again in {number} days": "Thử đăng nhập quá nhiều, hãy thử lại sau {number} ngày.",
    "Too many different sign-in attempts, try again in {number} hours": "Thử đăng nhập quá nhiều, hãy thử lại sau {number} giờ.",
    "Too many different sign-in attempts, try again in {number} minutes": "Thử đăng nhập quá nhiều, hãy thử lại sau {number} phút.",
    "Too many sign-up attempts, try again later": "Thử đăng ký quá nhiều, hãy thử lại sau",
    "Try free for {amount} days, then {originalPrice}.": "Đọc thử {amount} ngày, phí sau đọc thử là {originalPrice}.",
    "Unable to initiate checkout session": "Không thể bắt đầu phiên thanh toán",
    "Unlock access to all newsletters by becoming a paid subscriber.": "Trở thành thành viên trả phí để mở khóa truy cập toàn bộ bản tin email.",
    "Unsubscribe from all emails": "Hủy nhận tất cả email",
    "Unsubscribed": "Đã hủy nhận email",
    "Unsubscribed from all emails.": "Đã hủy nhận tất cả email",
    "Unsubscribing from emails will not cancel your paid subscription to {title}": "Việc hủy nhận email sẽ không hủy gói thành viên trả phí của bạn đối với {title}",
    "Update": "Cập nhật",
    "Update your preferences": "Cập nhật thiết lập",
    "Updates & announcements": "Cập nhật & thông báo",
    "Verification link sent, check your inbox": "Đã gửi liên kết xác minh, hãy kiểm tra email",
    "Verify your email address is correct": "Xác minh địa chỉ email của bạn là đúng",
    "Verifying...": "Đang xác minh...",
    "View plans": "Xem các gói",
    "We couldn't unsubscribe you as the email address was not found. Please contact the site owner.": "Chúng tôi không thể hủy gói vì không tìm thấy địa chỉ email. Vui lòng liên hệ với chủ sở hữu trang web.",
    "We'd hate to see you leave. How about a special offer to stay?": "Chúng tôi không muốn bạn rời đi. Bạn có muốn nhận ưu đãi đặc biệt để ở lại không?",
    "We'll email it to the recipient on {deliveryDate}. A copy is in your inbox too.": "",
    "We'll email it to the recipient. A copy will be in your inbox too.": "",
    "Welcome back, {name}!": "Chào mừng trở lại, {name}!",
    "Welcome back!": "Chào mừng trở lại!",
    "Welcome to {siteTitle}": "Chào mừng đến với {siteTitle}",
    "What's included": "",
    "When an inbox fails to accept an email it is commonly called a bounce. In many cases, this can be temporary. However, in some cases, a bounced email can be returned as a permanent failure when an email address is invalid or non-existent.": "Khi hộp thư đến không nhận được email, nó thường được gọi là email bị trả lại. Điều này có thể là tạm thời. Tuy nhiên, trong một số trường hợp, email bị trả lại có thể là lỗi vĩnh viễn nếu địa chỉ email không hợp lệ hoặc không tồn tại.",
    "Why has my email been disabled?": "Tại sao email của tôi bị vô hiệu hóa?",
    "X (Twitter)": "X (Twitter)",
    "year": "năm",
    "Yearly": "Hàng năm",
    "You already have an active subscription.": "Bạn đã có gói thành viên đang còn hiệu lực.",
    "You currently have a free membership, upgrade to a paid subscription for full access.": "Bạn đang là thành viên thường, hãy nâng cấp gói thành viên trả phí để có thể truy cập đầy đủ.",
    "You have been successfully resubscribed": "Bạn đã gia hạn gói thành công",
    "You now have access to {tierName} until {expiryDate}. Enjoy!": "Bạn đã có quyền lợi {tierName} cho đến {expiryDate}. Tận hưởng thôi!",
    "You're currently not receiving emails": "Hiện tại bạn không nhận email",
    "You're not receiving emails": "Bạn không nhận được bản tin email",
    "You're not receiving emails because you either marked a recent message as spam, or because messages could not be delivered to your provided email address.": "Bạn không nhận được bản tin email vì bạn đã đánh dấu một email gần đây là thư rác, hoặc vì địa chỉ email bạn cung cấp không thể gửi được.",
    "You've been gifted a <strong>{duration}-month</strong> {tierName} membership_other": "",
    "You've been gifted a <strong>{duration}-month</strong> {tierName} membership to {siteTitle}_other": "",
    "You've been gifted a <strong>{duration}-year</strong> {tierName} membership": "",
    "You've been gifted a <strong>{duration}-year</strong> {tierName} membership to {siteTitle}": "",
    "You've successfully signed in.": "Bạn đã đăng nhập thành công.",
    "You've successfully subscribed to <strong>{siteTitle}</strong>": "Bạn đã đăng ký thành công <strong>{siteTitle}</strong>",
    "Your account": "Tài khoản của bạn",
    "Your email": "Email của bạn",
    "Your email has failed to resubscribe, please try again": "Không thể gia hạn với email của bạn, vui lòng thử lại",
    "Your gift is on its way": "",
    "Your gift is ready": "Món quà của bạn đã sẵn sàng",
    "Your gift is scheduled": "",
    "Your gift subscription will expire on {expiryDate}": "Quà tặng gói thành viên sẽ hết hạn vào {expiryDate}",
    "your inbox": "hộp thư đến của bạn",
    "Your input helps shape what gets published.": "Thông tin bạn chọn giúp định hình nội dung được xuất bản.",
    "Your name": "Tên của bạn",
    "Your subscription has been canceled and will expire on {expiryDate}.": "Gói thành viên của bạn đã bị hủy và sẽ hết hạn vào {expiryDate}.",
    "Your subscription will expire on {expiryDate}": "Gói thành viên của bạn sẽ hết hạn vào {expiryDate}",
    "Your subscription will renew on {renewalDate}": "Gói thành viên của bạn sẽ tự động gia hạn vào {renewalDate}",
    "Your subscription will start on {subscriptionStart}": "Gói thành viên của bạn bắt đầu có hiệu lực vào {subscriptionStart}"
}
